// extracted by mini-css-extract-plugin
export default {"wrapper":"flight-assessment_wrapper__J3dQI","center":"flight-assessment_center__LR8UA"};